import React from 'react';

import Configuration from './Children/Configuration';
import Dashboard from './Children/Dashboard';
import Events from './Children/Events';
import Payments from './Children/Payments';
import Plans from './Children/Plans';
import Suscriptions from './Children/Suscriptions';

// TODO: Add scopes
export const StripeConfig = {
  settings: {
    layout: {
      config: {},
    },
  },
  routes: [
    {
      id: 'openPayGroup',
      path: 'open-pay',
      children: [
        {
          id: 'openPayGroup.dashboard',
          path: 'dashboard',
          element: <Dashboard />,
        },
        {
          id: 'openPayGroup.payments',
          path: 'payments',
          element: <Payments />,
        },
        {
          id: 'openPayGroup.suscriptions',
          path: 'suscriptions',
          element: <Suscriptions />,
        },
        {
          id: 'openPayGroup.plans',
          path: 'plans',
          element: <Plans />,
        },
        {
          id: 'openPayGroup.events',
          path: 'events',
          element: <Events />,
        },
        {
          id: 'openPayGroup.configuration',
          path: 'configuration',
          element: <Configuration />,
        },
      ],
    },
  ],
};
